"use client";
import { useAtomValue } from "jotai";
import { toolkitAtom } from "../store/layoutStore";
import Toolkit from "./core/Toolkit";

const ToolkitOutput = () => {
  const toolkit = useAtomValue(toolkitAtom);
  if (!toolkit) return null;
  return <Toolkit options={toolkit.options}>{toolkit.jsx}</Toolkit>;
};

export default ToolkitOutput;
